// Login Form Validation
$('#customer_login button[type="submit"], #customer_login button.button--full-width').click(function(e){
  var email = $('#CustomerEmail').val();
  var password = $('#CustomerPassword').val();
  
  // Remove all existing error messages
  $('#customer_login .form__message').remove();
  
  var hasError = false;
  
  // Validate email
  if(email.length < 1 || email.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#CustomerEmail').after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  // Validate password (only if password field exists)
  if($('#CustomerPassword').length > 0){
    if(password.length < 1 || password.trim().length === 0){
      e.preventDefault();
      hasError = true;
      $('#CustomerPassword').parent().after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
    }
  }
  
  if(hasError){
    e.preventDefault();
    return false;
  }
});

// Recover Password Form Validation (1 field - Email only)
$('#recover_customer_password button[type="submit"], #recover_customer_password .submit-button').click(function(e){
  var email = $('#RecoverEmail').val();
  
  // Remove all existing error messages
  $('#recover_customer_password .form__message').remove();
  
  // Validate email
  if(email.length < 1 || email.trim().length === 0){
    e.preventDefault();
    $('#RecoverEmail').after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
    return false;
  }
});

// Registration 
$('#create_customer button').click(function(e){
  var first_name = $('#RegisterForm-FirstName').val();
  var last_name = $('#RegisterForm-LastName').val();
  var email = $('#RegisterForm-email').val();
  var password = $('#RegisterForm-password').val();
  var password_confirmation = $('#RegisterForm-password-confirmation').val();
  
  // Remove all existing error messages
  $('.form__message').remove();
  
  var hasError = false;
  
  // Validate first name
  if(first_name.length < 1 || first_name.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-FirstName').after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  // Validate last name
  if(last_name.length < 1 || last_name.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-LastName').after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  // Validate email
  if(email.length < 1 || email.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-email').after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  // Validate password
  if(password.length < 1 || password.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-password').parent().after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  // Validate password confirmation
  if(password_confirmation.length < 1 || password_confirmation.trim().length === 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-password-confirmation').parent().after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  } else if(password !== password_confirmation && password.length > 0){
    e.preventDefault();
    hasError = true;
    $('#RegisterForm-password-confirmation').parent().after('<small class="form__message"><span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</small>');
  }
  
  if(hasError){
    e.preventDefault();
  }
});

// New Address
$('#AddAddress .add_address').click(function(e){
var first_name= $('#AddressFirstNameNew').val();
var address1= $('#AddressAddress1New').val();
var city= $('#AddressCityNew').val();
var zip= $('#AddressZipNew').val();
 var country= $('#AddressCountryNew').val();
$('.new-error').remove();

if(first_name.length<1 || first_name.indexOf(' ') == 0){
  e.preventDefault();
  $('#AddressFirstNameNew').after('<span class="new-error">This field is required</span>');
}

if(address1.length<1 || address1.indexOf(' ') == 0){
  e.preventDefault();
  $('#AddressAddress1New').after('<span class="new-error">This field is required</span>');
}

if(city.length<1 || city.indexOf(' ') == 0){
  e.preventDefault();
  $('#AddressCityNew').after('<span class="new-error">This field is required</span>');
}

if(zip.length<1 || zip.indexOf(' ') == 0){
  e.preventDefault();
  $('#AddressZipNew').after('<span class="new-error">This field is required</span>');
}

if(country.length<1 || country.indexOf(' ') == 0){
 e.preventDefault();
   $('#AddressCountryNew').after('<span class="new-error">This field is required</span>');
 }
}); 



// Edit Address
$('[id^=EditAddress_] .update_button').click(function(e){
// $('.custom-edit-address .button').click(function(e){
var first_name= $(this).parents('form').find('input.first_name').val();
var company= $(this).parents('form').find('input.company').val();
var address1= $(this).parents('form').find('input.address1').val();
var city= $(this).parents('form').find('input.city').val();
var country= $(this).parents('form').find('select.country').val();
var zip= $(this).parents('form').find('input.zip').val();
$('.new-error').remove();

if(first_name.length<1 || first_name.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('input.first_name').after('<span class="new-error">This field is required</span>');
}

if(company.length<1 || company.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('input.company').after('<span class="new-error">This field is required</span>');
}

if(address1.length<1 || address1.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('input.address1').after('<span class="new-error">This field is required</span>');
}

if(city.length<1 || city.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('input.city').after('<span class="new-error">This field is required</span>');
}

  if(country.length<1 || country.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('select.country').after('<span class="new-error">This field is required</span>');
}

if(zip.length<1 || zip.indexOf(' ') == 0){
  e.preventDefault();
  $(this).parents('form').find('input.zip').after('<span class="new-error">This field is required</span>');
}

}); 

// Login
$('#customer_login .login_button').click(function(e){
var cus_email = $('#CustomerEmail').val();
var cus_password = $('#CustomerPassword').val();
 $('.form__message').remove();

 if(cus_password.length<1 || cus_password.indexOf(' ') == 0){
  e.preventDefault();
  $('#CustomerPassword').after('<span class="form__message">This field is required</span>');
}

if(cus_email.length<1 || cus_email.indexOf(' ') == 0){
  e.preventDefault();
  $('#CustomerEmail').after('<span class="form__message">This field is required</span>');
}

});


function openReviewPage() {
// Get the product image URL and title from the current page
var productImage = document.querySelector('.product__media.media.media--transparent img')?.getAttribute('src') || '';
var productTitle = document.querySelector('.product__title h1')?.innerText || '';

// Build the URL with query parameters for the review submission page
var reviewPageURL = 'https://gifttree-dev.myshopify.com/pages/submit-a-review';
reviewPageURL += '?image=' + encodeURIComponent(productImage);
reviewPageURL += '&title=' + encodeURIComponent(productTitle);

// Redirect to the review submission page
window.location.href = reviewPageURL;
}

document.addEventListener("DOMContentLoaded", function() {
// Retrieve the query parameters from the URL
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const productImage = urlParams.get('image');
const productTitle = urlParams.get('title');

// Update the product image and title elements
const imgElement = document.getElementById('productImage');
const titleElement = document.getElementById('productTitle');

if (imgElement) {
  if (productImage && productImage.trim() !== '') {
    imgElement.src = productImage;
  } else {
    imgElement.style.display = 'none'; // Hide image if no src
  }
}

if (titleElement) {
  titleElement.textContent = productTitle || '';
}
});



$(document).ready(function() {
const buttons = $('.button.button--primary');

buttons.each(function() {
  const button = $(this);

  if (
    button.css('background-color') === 'rgb(221, 2, 2)' &&
    button.css('color') === 'rgb(255, 255, 255)'
  ) {
    button.addClass('effect_1');
  } else if (
    button.css('background-color') === 'rgb(255, 255, 255)' &&
    button.css('color') === 'rgb(0, 0, 0)'
  ) {
    button.addClass('effect_2');
  } else if (
    button.css('background-color') === 'rgba(0, 0, 0, 0)' &&
    button.css('color') === 'rgb(255, 255, 255)'
  ) {
    button.addClass('effect_3');
  }
});
});

$(document).ready(function() {
const buttons = $('button');
buttons.each(function() {
  const button = $(this);
  if (
    button.css('background-color') === 'rgb(221, 2, 2)' &&
    button.css('color') === 'rgb(255, 255, 255)'
  ) {
    button.addClass('effect_1');
  } else if (
    button.css('background-color') === 'rgb(255, 255, 255)' &&
    button.css('color') === 'rgb(0, 0, 0)'
  ) {
    button.addClass('effect_2');
  } else if (
    button.css('background-color') === 'transparent' &&
    button.css('color') === 'rgb(255, 255, 255)'
  ) {
    button.addClass('effect_3');
  }
});
});



// product gallery 


$(document).ready(function() {
  if ($(window).width() > 767) {
  $('.thumbnail-list.list-unstyled.slider').slick({
    slidesToShow: 5,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    vertical: true, // Enable vertical orientation
    verticalSwiping: true, // Enable vertical swiping
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });
}

});


$(document).ready(function() {
var firstVisibleTabContent = $(".description-main-box .description-box:visible:first");

if (firstVisibleTabContent.length === 0) {
    $(".description-main-box .description-box:first").show();
}

var activeTabLink = $(".descriptive-tabs ul li a.active");

if (activeTabLink.length === 0) {
    $(".descriptive-tabs ul li a:first").addClass("active");
}
});



// document.addEventListener('DOMContentLoaded', function() {
//     const button = document.querySelector('.multiship-footer a.multiship-checkout');
//     const buttonOffset = button.offsetTop;

//     window.addEventListener('scroll', function() {
//         if (window.pageYOffset > buttonOffset) {
//             button.classList.add('sticky');
//         } else {
//             button.classList.remove('sticky');
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
  const button = document.querySelector('.multiship-footer a.multiship-checkout');
  const placeholder = document.querySelector('.multiship-footer');

  // Exit early on pages that don't have the multiship footer
  if (!button || !placeholder) return;

  // Set the placeholder's height to match the button's height
  placeholder.style.height = `${button.offsetHeight}px`;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        button.classList.add('sticky');
      } else {
        button.classList.remove('sticky');
      }
    });
  }, {
    threshold: 1.0
  });

  observer.observe(placeholder);
});

// Prevent browser default validation messages for newsletter forms
$(document).ready(function() {
  // Disable browser validation for all newsletter form inputs
  $('.newsletter-form input[type="email"]').on('invalid', function(e) {
    e.preventDefault();
    return false;
  });
});

// Newsletter Form Email Validation
$(document).on('submit', '.newsletter-form form', function(e){
  var emailInput = $(this).find('#NewsletterEmail');
  var form = this;
  
  // Only proceed if this form has the NewsletterEmail input
  if(emailInput.length === 0){
    // If no NewsletterEmail, allow normal form submission
    return true;
  }
  
  // Always prevent default to stop browser validation
  e.preventDefault();
  
  var email = emailInput.val();
  var inputGroup = emailInput.closest('.newsletter-form__input-group');
  var errorMessage = $('#NewsletterEmail-error');
  
  // Remove any existing error styling
  emailInput.removeClass('input-error');
  inputGroup.removeClass('has-error');
  errorMessage.hide().empty();
  
  // Email validation regex pattern
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // Check if email is empty
  if(email.length < 1 || email.trim().length === 0){
    emailInput.addClass('input-error');
    inputGroup.addClass('has-error');
    errorMessage.html('<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>This field is required</span>').show();
    emailInput.focus();
    return false;
  }
  
  // Check if email format is valid
  if(!emailPattern.test(email.trim())){
    emailInput.addClass('input-error');
    inputGroup.addClass('has-error');
    errorMessage.html('<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg></span>Please enter a valid email address</span>').show();
    emailInput.focus();
    return false;
  }
  
  // If validation passes, submit the form using native submit method (doesn't trigger submit event)
  var formElement = form;
  if (formElement && formElement.nodeName === 'FORM') {
    // Remove event handler temporarily to prevent loop
    $(formElement).off('submit');
    // Use native submit which bypasses submit event
    formElement.submit();
  }
});

// Clear error message when user starts typing
$(document).on('input', '#NewsletterEmail', function(){
  var emailInput = $(this);
  var inputGroup = emailInput.closest('.newsletter-form__input-group');
  var errorMessage = $('#NewsletterEmail-error');
  emailInput.removeClass('input-error');
  inputGroup.removeClass('has-error');
  errorMessage.hide().empty();
});



















